module.exports = __webpack_public_path__ + "static/img/order2.040fa47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order2.png
// module id = Fu64
// module chunks = 1